<script setup>
const props = defineProps({
  variant: {
    type: String,
    default: undefined,
  },
});
</script>

<template>
  <a
    class="btn pagination-short__button"
    :class="{ [`pagination-short__button--${props.variant} btn--primary`]: variant }"
  >
    <slot />
  </a>
</template>
